import styled from 'styled-components';

// Shared with DownloadFormatMenu.tsx's position calculation so the panel's
// actual rendered width can't drift from the number used to place it.
export const PANEL_WIDTH = 140;

export const MenuWrapper = styled.div`
  position: relative;
  display: inline-flex;
`;

export const MenuTrigger = styled.button<{ $isOpen?: boolean; $iconOnly?: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  font-family: inherit;
  transition: all 0.2s ease;

  ${({ $iconOnly }) =>
    $iconOnly
      ? `
    background: transparent;
    border: none;
    padding: 4px;
    border-radius: 0.375rem;
    color: var(--allie-color-neutral-50);

    &:hover {
      background: var(--allie-color-neutral-10);
      color: var(--allie-color-primary-90);
    }
  `
      : `
    border: 1.5px solid var(--allie-color-neutral-20);
    background: var(--allie-color-white);
    color: var(--allie-color-primary-90);
    font-size: 0.875rem;
    font-weight: 600;
    padding: 0.6rem 1.1rem;
    border-radius: 8px;

    &:hover {
      filter: brightness(0.97);
    }
  `}

  ${({ $isOpen, $iconOnly }) =>
    $isOpen && !$iconOnly && `border-color: var(--allie-color-primary-main);`}
  ${({ $isOpen, $iconOnly }) =>
    $isOpen && $iconOnly && `background: var(--allie-color-neutral-10);`}

  svg {
    width: 16px;
    height: 16px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const MenuChevron = styled.span<{ $isOpen?: boolean }>`
  display: flex;
  align-items: center;
  color: var(--allie-color-neutral-50);
  transition: transform 0.2s ease;
  transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};

  svg {
    width: 14px;
    height: 14px;
  }
`;

/**
 * Rendered via ReactDOM.createPortal to document.body, same positioning
 * approach as AssignDropdown.
 */
export const MenuPanel = styled.div<{ $placement: 'top' | 'bottom' }>`
  position: fixed;
  background: var(--allie-color-white);
  border: 1px solid var(--allie-color-neutral-20);
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  z-index: 10001;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: ${PANEL_WIDTH}px;
  transform: ${({ $placement }) => ($placement === 'top' ? 'translateY(-100%)' : 'none')};
`;

export const MenuErrorText = styled.span`
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 4px;
  max-width: 220px;
  white-space: normal;
  font-size: 0.8125rem;
  color: var(--allie-color-error-main);
`;

export const MenuItem = styled.button<{ $variant?: 'default' | 'xlsx' }>`
  display: flex;
  align-items: center;
  width: 100%;
  border: none;
  background: transparent;
  padding: 0.625rem 0.75rem;
  cursor: pointer;
  font-size: 0.9375rem;
  font-family: inherit;
  text-align: left;
  color: ${({ $variant }) =>
    $variant === 'xlsx' ? 'var(--allie-color-success-main)' : 'var(--allie-color-primary-90)'};
  transition: background 0.15s ease;

  &:hover {
    background: var(--allie-color-neutral-10);
  }
`;
